import React, { useEffect } from "react";
import {useGetBalance} from "./hooks/useGetBalance";
function shortenNumber(num) {
    if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
    if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
    return num.toString();
}
export function Dashboard({ userData, onLogout }) {
    const {userAddress, balance} = useGetBalance()

    return (
        <div className="min-h-screen bg-gradient-to-br from-yellow-400 via-yellow-300 to-amber-400">
            {/* Header */}
            <div className="bg-black text-yellow-400 py-6 shadow-lg border-b-4 border-yellow-400">
                <div className="container mx-auto px-4 flex justify-between items-center">
                    <a
                        href="/"
                        className="flex items-center space-x-3 p-3 rounded-xl transition transform hover:scale-105 hover:bg-yellow-400 hover:text-black cursor-pointer"
                    >
                        <div className="text-4xl">🥕🪵</div>
                        <h1 className="text-3xl font-bold">Carrot & Stick</h1>
                    </a>
                    {userData ? <button
                        onClick={onLogout}
                        className="bg-yellow-400 text-black px-4 py-2 rounded-lg font-bold hover:bg-yellow-300 transition-colors border-2 border-black"
                    >
                        Logout
                    </button>
                        : <a
                            href="/"
                            className="flex items-center space-x-3 p-3 rounded-xl transition transform hover:scale-105 hover:bg-yellow-400 hover:text-black cursor-pointer"
                        >
                            Login
                        </a>}
                </div>
            </div>

            {/* Welcome Section */}
            <div className="container mx-auto px-4 py-8 max-w-4xl">
                <div className="bg-black rounded-2xl shadow-2xl p-8 mb-6 border-4 border-yellow-400">
                    <div className="text-center mb-6">
                        <h2 className="text-4xl font-bold text-yellow-400 mb-2">
                            Welcome to the Game! 🎮
                        </h2>
                        {
                            userData ? (
                                <>
                                    <p className="text-xl text-yellow-300">
                                        Registered as: <span className="font-bold text-yellow-400">{userData.email}</span>
                                    </p>
                                    <p className="text-sm text-yellow-200 mt-1">
                                        Twitter: @{userData.twitter_screen_name}
                                    </p>
                                    <p className="text-sm text-yellow-200 mt-1">
                                        Address: {userAddress}
                                    </p>

                                </>
                            ) : null
                        }
                        <div className="max-w-md mx-auto mt-8 p-6 bg-black/50 border-4 border-yellow-400 rounded-2xl shadow-2xl backdrop-blur-md">
                            {/* Title */}
                            <h2 className="text-2xl font-bold text-yellow-400 text-center mb-6 uppercase tracking-widest">
                                🎒 Your Inventory
                            </h2>

                            {/* Inventory Items */}
                            <div className="flex justify-center items-center space-x-4">
                                {/* 🥕 Carrot */}
                                <div className="flex flex-col items-center justify-center w-24 h-24 bg-black/40 border-2 border-yellow-400 rounded-xl shadow-lg hover:scale-105 transition transform cursor-pointer">
                                    <span className="text-3xl mb-1">🥕</span>
                                    <span className="text-yellow-400 font-bold text-lg">{shortenNumber(balance.carrot)}</span>
                                </div>

                                {/* 🪵 Stick */}
                                <div className="flex flex-col items-center justify-center w-24 h-24 bg-black/40 border-2 border-yellow-400 rounded-xl shadow-lg hover:scale-105 transition transform cursor-pointer">
                                    <span className="text-3xl mb-1">🪵</span>
                                    <span className="text-yellow-400 font-bold text-lg">{shortenNumber(balance.stick)}</span>
                                </div>

                                {/* ✨ Magic */}
                                <div className="flex flex-col items-center justify-center w-24 h-24 bg-black/40 border-2 border-yellow-400 rounded-xl shadow-lg hover:scale-105 transition transform cursor-pointer">
                                    <span className="text-3xl mb-1">✨</span>
                                    <span className="text-yellow-400 font-bold text-lg">{shortenNumber(balance.magic)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* How to Play */}
                    <div className="flex justify-center">
                        <button
                            onClick={() => (window.location.href = "/rules")}
                            className="inline-flex items-center justify-center space-x-2 bg-transparent border-2 border-yellow-400 text-yellow-400 font-semibold py-3 px-6 rounded-xl transition transform hover:scale-105 hover:bg-yellow-400 hover:text-black cursor-pointer"
                        >
                            <span className="text-2xl">📜</span>
                            <span className="text-lg font-bold">View Rules</span>
                        </button>
                    </div>

                </div>

                {/* Footer Meme */}
                <div className="text-center py-6">
                    <p className="text-black italic text-lg font-bold">
                        "In Carrot & Stick we trust" 🥕🪵
                    </p>
                    <p className="text-black text-sm mt-2">
                        Disclaimer: This is probably a scam. But a fun one! 😉
                    </p>
                </div>
            </div>
        </div>
    );
}
